/**
 * IMPORTS
 */

import { IEnderecoResponseAtualizar } from "@/hooks/enderecos/atualizar/index.d";

import { enderecosRepository } from "@/repositories/enderecos";

/**
 * Função que atualizar os dados do endereço 🛠️.
 */
const handleAtualizarEndereco = async (
  accessToken: string,
  endereco_id: number,
  payload: IEnderecoResponseAtualizar
) => {
  try {
    const data = await enderecosRepository.atualizarEndereco(accessToken, endereco_id, payload);

    return data;
  } catch (error: any) {
    console.log("ERROR AO ATUALIZAR ENDEREÇO: ", error);

    return error;
  }
};

/**
 * EXPORTS
 */
export { handleAtualizarEndereco };
